import React, { useEffect, useState } from 'react';

//倒计时组件
function CountdownComponent({ seconds, style, setVideoState }: any) {
  const [countdown, setCountdown] = useState(seconds);

  // Convert seconds to mm:ss format
  const formatCountdown = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes < 10 ? '0' : ''}${minutes}:${
      remainingSeconds < 10 ? '0' : ''
    }${remainingSeconds}`;
  };

  useEffect(() => {
    // Start the countdown timer
    const interval = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
      // if(countdown==0){
      //   setVideoState('trySeeEnd');
      // }
    }, 1000);

    // Clean up the interval when the component is unmounted
    return () => {
      clearInterval(interval);
    };
  }, []);

  return <span style={style}>{formatCountdown(countdown)}</span>;
}
export default CountdownComponent;
